module.exports = __webpack_public_path__ + "img/VF.1ecbb6d7.png";